import React, { useCallback, useMemo } from "react";
import { connect } from "react-redux";
import axios from "axios";
import notify from "devextreme/ui/notify";
import { Button } from "devextreme-react/button";
import FormField from "../../dynamicFormBuilder/FormField";
import { DetailMiscLayout } from "./Layout";
import { loadLookupFromDataSource, GetFormatedDateWithTime } from "../../common/Utils";
import { CONCURRENCY_HANDLED, getApiErrorMessage } from "../../common/concurrency";
import data from "../../assets/apiRoutes.json";
import { EMPTY_GUID } from "../../const/constants";

const ROUTES = data.IM.ItemManagement;

// Details -> "Miscellaneous" sub-tab (Delphi uIMD0019 "EF Interface"): meter / participant / fuel fields for
// the SELECTED line. Editable; Save posts the whole line (UpdateTransactionDetailByRowId).
function DetailMiscTab(props) {
    const currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const accessToken = props.oidc?.user?.access_token;

    const line = props.formFields || {};
    const hasLine = line.rowid && line.rowid !== EMPTY_GUID;
    const editable = hasLine && !props.disabled;

    const finalLayout = useMemo(() => DetailMiscLayout, []);

    const handleSelectionChange = useCallback((name, value, e) => {
        if (props.handleFieldChange) props.handleFieldChange(name, value, e);
    }, [props.handleFieldChange]);

    // Coded dropdowns. Participant has a dedicated endpoint; Meter ID and State (fuel/misc taxes) use the
    // generic lookup as a best guess — confirm/adjust these two if their dropdowns come up empty.
    const loadLookups = useCallback(() => {
        const apis = window._env_.REACT_APP_APIS;
        const rp = props.formRefs;
        const ff = props.formFields;
        loadLookupFromDataSource(accessToken, ff, rp, "participantId", `${apis}/${data.ID.GetParticipants}`, "id", "name");
        loadLookupFromDataSource(accessToken, ff, rp, "meterId", `${apis}/${data.Common.GetLookup}`, "id", "name", { module: "IM", lookupType: "Meter", showLookupGrid: false });
        loadLookupFromDataSource(accessToken, ff, rp, "fuelTaxId", `${apis}/${data.Common.GetLookup}`, "id", "name", { module: "ID", lookupType: "FuelAndMiscTaxes", showLookupGrid: false });
    }, [accessToken, props.formRefs, props.formFields]);

    const handleFormLoad = useCallback(() => { setTimeout(loadLookups, 100); }, [loadLookups]);

    const save = useCallback(() => {
        if (!hasLine) { notify("Select a detail line first.", "warning", 3000); return; }
        const payload = { ...line, transactionDate: line.transactionDate ? GetFormatedDateWithTime(line.transactionDate) : null };
        axios.post(`${window._env_.REACT_APP_APIS}/${ROUTES.UpdateTransactionDetailByRowId}`, payload, {
            headers: {
                access_token: accessToken,
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
            },
        }).then((res) => {
            notify("Miscellaneous saved.", "success", 3000);
            if (props.onSaved) props.onSaved(res.data);
        }).catch((err) => {
            if (err?.[CONCURRENCY_HANDLED]) return;
            notify(getApiErrorMessage(err, "Failed to save miscellaneous."), "error", 5000);
        });
    }, [hasLine, line, accessToken, props]);

    if (!hasLine) {
        return <div style={{ padding: 16, color: "#888" }}>Select a detail line to view or edit its miscellaneous fields.</div>;
    }

    return (
        <div>
            <div style={{ textAlign: "right", marginBottom: 4 }}>
                <Button text="Save" type="default" onClick={save} disabled={!editable} />
            </div>
            <FormField
                currrentUser={currentUser}
                layoutId="AF0833C4-D571-4132-9B84-DBFB9A398494"
                layoutName="IMTransactionEntryDetailMiscForm"
                defaultFormSchema={finalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleSelectionChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handleFormLoad}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return { oidc: state.oidc };
}

export default connect(mapStateToProps)(DetailMiscTab);
